import { Component, Vue } from 'vue-property-decorator';
import { authService } from '@/services/auth-service';
import { LoggedInUser } from '@/models/authentication/logged-in-user';

@Component
export default class UserMenu extends Vue {
    get user(): LoggedInUser {
        return authService.user;
    }

    async logout(): Promise<void> {
        await authService.logOut();
        this.$router.push('/login');
    }
}
